module.exports = __webpack_public_path__ + "static/img/bg19.e4b8b4fd.png";